import Description from '@mui/icons-material/Description';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DescriptionIcon(props: FixMe) {
  return <Description {...props} />;
}

export default DescriptionIcon;
